var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsMessage = function SvgNewsMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 2.02502H5.83073C3.33073 2.02502 1.66406 3.69169 1.66406 6.19169V11.1917C1.66406 13.6917 3.33073 15.3584 5.83073 15.3584H9.16406L12.8724 17.825C13.4224 18.1917 14.1641 17.8 14.1641 17.1334V15.3584C16.6641 15.3584 18.3307 13.6917 18.3307 11.1917V6.19169C18.3307 3.69169 16.6641 2.02502 14.1641 2.02502ZM12.9141 9.37502H7.08073C6.73906 9.37502 6.45573 9.09169 6.45573 8.75002C6.45573 8.40836 6.73906 8.12502 7.08073 8.12502H12.9141C13.2557 8.12502 13.5391 8.40836 13.5391 8.75002C13.5391 9.09169 13.2557 9.37502 12.9141 9.37502Z",
    fill: "currentColor"
  })));
};
export default SvgNewsMessage;